import zeroPad from '~/shared/utils/string/zeroPad';

const buildOptions = (min: number, max: number, reverse?: boolean) => {
  const optionList = range(min, max).map((option) => (
    <option key={option} value={option}>
      {zeroPad(option)}
    </option>
  ));
  const options = reverse ? optionList.reverse() : optionList;
  return (
    <>
      <option value="" disabled />
      {options}
    </>
  );
};

const range = (min: number, max: number) =>
  Array.from({ length: max - min + 1 }, (_, i) => i).map((_, n) => n + min);

export default buildOptions;
